import { Add } from '@material-ui/icons';
import React from 'react';
import styled from 'styled-components';
const Container = styled.div`
  text-align: left !important;
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  clear: both;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 28px;
  padding: 5px 10px 5px 5px;

  :hover {
    border-color: #000;
  }

  > svg {
    vertical-align: middle;
    float: left;
    font-size: 19px;
    margin-right: 5px;
  }

  > span {
    vertical-align: middle;
    display: flex;
    float: left;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    letter-spacing: -0.2px;
  }

  > a {
    display: flex;
    text-decoration: none !important;
    color: black !important;
  }

  > .add-menu-item {
    vertical-align: middle;
  }
`;

function AddButton(props) {
  return (
    <Container onClick={props.onClick}>
      <Add /> <span>{props.children}</span>
    </Container>
  );
}

export default AddButton;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/AddButton/index.jsx